import {Pipe, PipeTransform} from '@angular/core';
import {ProviderCatalogDto} from '../../../Models/Purchases/Providers/provider.interface';

@Pipe({
  name: 'providerCatalog',
  standalone: false,
})
export class ProviderCatalogPipe implements PipeTransform {

  transform(items: ProviderCatalogDto[], filter: { family: number }): ProviderCatalogDto[] {

    if (!items || items.length === 0) {
      return [];
    }

    if (filter.family) {
      items = items.filter((item) => item.id_familia === filter.family);
    }

    return items;

  }

}
